import { useEffect,useState } from 'react';
import './App.css';
import Card from "./components/Card/Card";
import Navbar from './components/Navbar/Navbar';
import { getAllPokemon,getPokemon } from "./utils/pokemon";


function App() {
  const initialURL = "https://pokeapi.co/api/v2/pokemon";
  const [loading, setLoading] = useState(true);
  const [pokemonData, setPokemonData] = useState([]);
  const [nextURL, setNextURL] = useState("");
  const [prevURL, setPrevURL] = useState("");

  useEffect(() => {
    const fetchPokemonData = async () => {
      //ブラウザをリロードした時にポケモンデータを全取得するようにする
      let res = await getAllPokemon(initialURL);
      //各ポケモンの詳細データを取得
      loadPokemon(res.results);
      //次の20匹のポケモンのURL
      setNextURL(res.next);
      //前の20匹のポケモンのURL
      setPrevURL(res.previous);
      setLoading(false);
    };
    fetchPokemonData();
  }, [])

  const loadPokemon = async (data) => {
    let _PokemonData = await Promise.all(
      data.map((pokemon) => {
        let pokemonRecord = getPokemon(pokemon.url);
        return pokemonRecord;
      })
    );
    setPokemonData(_PokemonData)
  }

  // console.log(pokemonData);

  //前へと次へボタンを押下することでポケモンデータを取得する
  const handleNextPage = async () => {
    setLoading(true);
    let data = await getAllPokemon(nextURL);
    //  console.log(data);
    await loadPokemon(data.results);
    //次へボタンを押下するたびにnextURLが更新されるので、3p,4p,5pと次のページへと画面遷移する
    setNextURL(data.next);
    //前へボタンを押下するたびにprevURLが更新されるので、1p,2p,3pと次のページへと画面遷移する
    setPrevURL(data.previous);
    setLoading(false);
  }
  const handlePrevPage = async () => {
    //1p目は前へボタン押下しても意味ないので何も返さないように設定
    if (!prevURL) return;

    setLoading(true);
    let data = await getAllPokemon(prevURL);
    await loadPokemon(data.results);
    //次へボタンを押下するたびにnextURLが更新されるので、3p,4p,5pと次のページへと画面遷移する
    setNextURL(data.next);
    //前へボタンを押下するたびにprevURLが更新されるので、1p,2p,3pと次のページへと画面遷移する
    setPrevURL(data.previous);
    setLoading(false);
  }

  return (
    <>
      <Navbar />
        <div className="App">
          {loading ? (
          <h1>ロード中・・・</h1>
           ) : (
          <>
            <div className="pokemonCardContainer">
                {pokemonData.map((pokemon, i) => {
                return <Card key={i} pokemon={pokemon} />
                })}
            </div>
            <div className="btn">
              <button onClick={handlePrevPage}>前へ</button>
              <button onClick={handleNextPage}>次へ</button>
            </div>
          </>
          )}
        </div>
    </>
  );
}

export default App;
